import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function SEO({ title, description, keywords, image, url, type = 'website', schema, canonical }) {
  // We keep useLocation to ensure the component re-renders on route changes
  const location = useLocation();
  const siteTitle = 'Pokemon Stats Database';
  const siteDescription = 'Complete Pokemon Stats Database with 1,215+ Pokemon, detailed statistics, abilities, types, and comparison tools';
  const siteUrl = 'https://example.com';

  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Complete Pokemon Reference & Statistics`;
  const fullDescription = description || siteDescription;
  
  // Dynamic URL construction for HashRouter:
  // We exclusively use window.location.hash to ensure we capture the exact full path 
  // as it appears in the browser (e.g., "#/pokemon/pidgey?tab=stats").
  // This guarantees the canonical URL matches the HashRouter structure.
  const currentPath = window.location.hash;
  
  // Fallback to provided 'url' prop only if necessary (e.g. if hash is empty for some reason)
  const path = currentPath || url;
  
  // Handle absolute vs relative paths
  // Ensure we add a slash before the hash if strictly appending to domain, 
  // resulting in https://example.com/#/path
  const fullUrl = path && path.startsWith('http') 
    ? path 
    : `${siteUrl}${path && path.startsWith('#') ? '/' : ''}${path}`;
  
  const fullImage = image || `${siteUrl}/pokemon-og.jpg`;
  const canonicalUrl = canonical || fullUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

export default SEO;